import { postMethod } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';

// Action Creators
export const fetchForgotPassword = () => ({
  type: FORGOT_PASSWORD,
});

export const fetchForgotPasswordSuccess = (data) => ({
  type: FORGOT_PASSWORD_SUCCESS,
  payload: data,
});

export const fetchForgotPasswordFailure = (error) => ({
  type: FORGOT_PASSWORD_FAILURE,
  payload: error,
});

// Thunk Function
export const forgotPasswordCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchForgotPassword(data, external));
    try {
      const response = await postMethod(url.forgetPassword, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchForgotPasswordSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchForgotPasswordFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchForgotPasswordFailure(error.message));
    }
  };
};
